import { Component, OnInit } from '@angular/core';
import { SectionBuilderStoreService } from '../../../sections-editor/shared-section-builder/section-builder-store.service';
import { HeroLayoutEnum, Section } from '@urbannex/storethemes';
import { EditState } from '../../../../model';


@Component({
  selector: 'kve-hero-image-layout-templates',
  templateUrl: './hero-image-layout-templates.component.html',
  styleUrls: ['./hero-image-layout-templates.component.scss']
})
export class HeroImageLayoutTemplatesComponent implements OnInit{
  
  collapsed:boolean;
  section: Section;

  constructor(private sectionBuilderStoreService:SectionBuilderStoreService){}
  ngOnInit(): void {
    this.sectionBuilderStoreService.section$.subscribe(section => {
      this.section = section;
      console.log(section)
    })
  }


  createGrid(layout:number){
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
    let selectedLayout;
    let heroImageLayoutEnum:HeroLayoutEnum;
    switch (layout) {
      case 1:
        selectedLayout = "layout-1";
        heroImageLayoutEnum = HeroLayoutEnum.LAYOUT_1;
        
        //this.section.title = null;
        break;
      case 2:
        selectedLayout = "layout-2"
        heroImageLayoutEnum = HeroLayoutEnum.LAYOUT_2;
        //this.section.title = null;
        break;
      case 3:
        selectedLayout = "layout-3"
        heroImageLayoutEnum = HeroLayoutEnum.LAYOUT_3;
        //gridCells = this.createGridCells("grid-6");
        //this.section.title = null;
        break;
      case 4:
        selectedLayout = "layout-4"
        heroImageLayoutEnum = HeroLayoutEnum.LAYOUT_4;
        //gridCells = this.createGridCells("grid-6");
        //this.section.title = null;
        break;
      case 5:
        selectedLayout = "layout-5"
        heroImageLayoutEnum = HeroLayoutEnum.LAYOUT_5;
        //gridCells = this.createGridCells("grid-6");
        //this.section.title = null;
        break;
      case 6:
        selectedLayout = "layout-6"
        heroImageLayoutEnum = HeroLayoutEnum.LAYOUT_6;
        //gridCells = this.createGridCells("grid-6");
        //this.section.title = null;
        break;
      default:
        break;
    }
    if(heroImageLayoutEnum !== this.section.sectionData.layoutClass){
      this.section.sectionData.layoutClass = heroImageLayoutEnum;
      this.sectionBuilderStoreService.updateSection(this.section);
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED)          
    }
  }

  toggleContainer(){

  }
}
